export default __webpack_public_path__ + "static/media/kf-8.fc60f51f.png";